import { useEffect, useState } from 'react'
import { useRefreshTwitterProfileMutation } from '../modules/user/api'
import { getProfileImageUrl } from '../utils/users'

const useTwitterProfileImage = (user: {
  metadata?: { twitter?: { id: string; profile_image_url?: string } }
}) => {
  const [status, setStatus] = useState('loading')
  const [refreshTwitterProfile, { data }] = useRefreshTwitterProfileMutation()

  const twitterUserId = user?.metadata?.twitter?.id
  const url = user?.metadata?.twitter?.profile_image_url

  useEffect(() => {
    const image = new Image()

    image.src = url
    image.onload = () => {
      setStatus('image loaded')
      console.log('loaded')
    }
    image.onerror = () => {
      if (!twitterUserId) return
      refreshTwitterProfile({ body: { twitterUserId } })
    }

    return () => {
      image.onload = null
      image.onerror = null
    }
  }, [refreshTwitterProfile, twitterUserId, url])

  return {
    url: getProfileImageUrl(data?.refreshTwitterProfile?.user ?? user),
    status,
  }
}

export default useTwitterProfileImage
